import styled from 'styled-components';

import { Button } from '@hivebrite/design-system/Button';

import { DefaultLink } from 'hb-react/frontoffice/components/Link';

const SecondaryButtonWrapper = ({ url, children }) => (
  <DefaultLinkStyled
    href={url}
    data-bypass-router
    target="_blank"
    tabIndex={-1}
  >
    {children}
  </DefaultLinkStyled>
);

export const ButtonCustom = ({ url, label }) => (
  <SecondaryButtonWrapper url={url}>
    <Button isFullWidth variant="secondary">
      {label}
    </Button>
  </SecondaryButtonWrapper>
);

const DefaultLinkStyled = styled(DefaultLink)`
  min-width: 0;
`;
